import { AccredibleBaseFooterComponentModule } from '@accredible-frontend-v2/components/base-components/base-footer';
import { AccredibleLanguageSelectorComponent } from '@accredible-frontend-v2/components/language-selector';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
// import { ExternalLinkDirectiveModule } from '../../../core/directives/external-link/external-link.directive.module';
import { FooterComponent } from './footer.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    // FIXME(Matt): Re-enable this when the cookies PR is merged
    // ExternalLinkDirectiveModule,
    AccredibleBaseFooterComponentModule,
    AccredibleLanguageSelectorComponent,
    TranslocoModule,
  ],
  exports: [FooterComponent],
  declarations: [FooterComponent],
  providers: [],
})
export class FooterComponentModule {}
